
import { usePermissions, UserPermission, WriteOn, ReadOn } from 'modules/permissions';
import { ConditionalRender } from 'components/layout/ConditionalRender';
import {
    StyledSubHeader,
    StyledSubHeaderGroup,
    StyledSubHeaderSection,
    StyledSubHeaderTabContainer
} from 'shared/styled/SubHeader.styled';
import SubHeaderTab from 'components/SubHeaderTab';
import { FontIcon } from '@fluentui/react';
import { CategoryDisplayEnum } from '../../enums/category-display.enum';
import { useTranslation } from 'react-i18next';

interface CategorySubHeaderProps {
    displayMode: CategoryDisplayEnum;
    formHasErrors: boolean;
    goToOverview: () => void;
    goToAuditLog: () => void;
}

const CategorySubHeader = ({    
    displayMode,
    formHasErrors,
    goToOverview,
    goToAuditLog
}: CategorySubHeaderProps) =>{
    
    const { hasPermission } = usePermissions();    
    const { t } = useTranslation();

    return (
        <StyledSubHeader>
            <StyledSubHeaderSection style={{ flex: '2 1 auto' }}>
                <StyledSubHeaderGroup style={{ justifyContent: 'flex-end' }}>
                    <StyledSubHeaderTabContainer>
                        <SubHeaderTab
                            onClick={goToOverview}
                            isActive={displayMode === CategoryDisplayEnum.Overview}
                            display={t('Category.Overview')}
                            highlightErrors={formHasErrors}
                        />                        
                        <ConditionalRender condition={hasPermission(ReadOn(UserPermission.Audit))}>
                            <SubHeaderTab
                                onClick={goToAuditLog}
                                isActive={displayMode === CategoryDisplayEnum.Audit}
                                display={<FontIcon iconName='History' />}
                                title={t('Category.AuditLog')}
                            />
                        </ConditionalRender>
                    </StyledSubHeaderTabContainer>
                </StyledSubHeaderGroup>               
            </StyledSubHeaderSection>
        </StyledSubHeader>
    )
};

export default CategorySubHeader;